/**
 * 图片上传
 * @author xiao.xu 2018.11.20
 */
import React from 'react';
import { Icon, Loading } from '@ok/okd';

import { ShowLargeImg } from '_common/components/showBigImg/ShowBigImg';
import { translate } from '_common/utils/language';

import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemUpload extends ItemContext {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
      photoItem: {}, // 单个图片
    };
    this.imgInput = null;
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
  }

  /**
   * 选择文件变化监听
   * @param e
   */
  onChange = (e) => {
    const chosenFile = e.target.files[0];
    let imgType = e.target.getAttribute('data-type');
    imgType = parseInt(imgType, 10);
    const { key, onChange, formType, extend } = this.props.dataSource;
    const allow = true;
    if (onChange) {
      const ret = onChange(key, formType, imgType, chosenFile, allow, extend);
      // if return a Promise
      if (ret && ret.then) {
        this.setState({ loading: true });
        // eslint-disable-next-line promise/catch-or-return
        ret.then(
          () => {
            this.setState({ loading: false });
            if (this.imgInput) {
              this.imgInput.value = '';
            }
          },
          () => {
            this.setState({ loading: false });
            if (this.imgInput) {
              this.imgInput.value = '';
            }
          }
        );
      }
    }
  };

  /**
   * 删除
   */
  onDelete = (item) => {
    const type = item.type;
    const { key, onDelete, formType, extend } = this.props.dataSource;
    onDelete && onDelete(key, formType, type, extend);
  };

  onShowBigImg = (url) => {
    const { openNew } = this.props.dataSource;

    if (openNew) {
      const a = document.createElement('a');
      a.href = url;
      a.target = url;
      document.body.appendChild(a);
      a.click();
    } else {
      ShowLargeImg.show({ url });
    }
  };

  // 渲染上传位置
  renderUpload = (item) => {
    return (
      <div className="upload-section">
        <Loading loading={!!this.state.loading} hasMask />
        <div className="upload-hint">
          <span className="icon-circle">
            <Icon className="upload-icon okds-share" />
          </span>
          {item.title && <p className="upload-text">{item.title}</p>}
        </div>
        <input
          className="upload-input"
          type="file"
          data-type={item.type}
          accept="image/jpeg,image/jpg,image/png"
          onChange={this.onChange}
          ref={(c) => {
            this.imgInput = c;
          }}
        />
      </div>
    );
  };

  // 渲染图片显示
  renderShowImg = (item) => {
    return (
      <div className="upload-img-section">
        <img src={item.imgUrl} className="upload-show-img" alt="" />
        <div className="mask">
          {/* 放大按钮 */}
          <span
            className="icon-box"
            onClick={() => {
              this.onShowBigImg(item.imgUrl);
            }}
          >
            <Icon className="icon okds-search" />
          </span>
          {/* 删除按钮 */}
          <span
            className="icon-box"
            onClick={() => {
              return this.onDelete(item);
            }}
          >
            <Icon className="icon okj-account-eliminate" />
          </span>
        </div>
      </div>
    );
  };

  // 渲染样例图片显示
  renderSampleImg = () => {
    // openNew 示例图片是否打开新tab
    const { sample, sampleSmall } = this.props.dataSource;
    if (!sample || sample.length === 0) {
      return null;
    }
    return (
      <div className="upload-item">
        <div className="upload-img-section">
          <img src={sampleSmall} className="upload-show-img" alt="" />
          <div className="mask sample-mask">
            <div
              className="sample"
              data-src={sampleSmall || sample}
              onClick={() => {
                this.onShowBigImg(sample);
              }}
            >
              <span className="icon">
                <Icon className="icon okds-search" />
              </span>
              <div className="sample-text">
                {translate('user.inter.view.demo')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 同类型上传渲染
  renderSameTypeUpload() {
    const { inputList, title } = this.props.dataSource;
    let uploadIndex = -1;
    return (
      <React.Fragment>
        {inputList &&
          inputList.map((item, index) => {
            let comp = null;
            if (item.imgUrl) {
              comp = (
                <div className="upload-item" key={index}>
                  {this.renderShowImg(item)}
                </div>
              );
            } else if (uploadIndex < 0) {
              uploadIndex = index;
            }
            return comp;
          })}
        {uploadIndex >= 0 && (
          <div className="upload-item">
            {this.renderUpload({
              title: inputList[uploadIndex].title || title,
              type: inputList[uploadIndex].type,
            })}
          </div>
        )}
      </React.Fragment>
    );
  }

  // 多类型上传渲染
  renderMultiTypeUpload() {
    const { inputList } = this.props.dataSource;
    return (
      <React.Fragment>
        {inputList &&
          inputList.map((item, index) => {
            return (
              <div className="upload-item" key={index}>
                {item.imgUrl
                  ? this.renderShowImg(item)
                  : this.renderUpload(item)}
              </div>
            );
          })}
      </React.Fragment>
    );
  }

  // 渲染右侧提示
  renderTipsRight() {
    const { tipsRight } = this.props.dataSource;
    if (!tipsRight || tipsRight.length === 0) {
      return null;
    }
    return (
      <div className="tips-right-box">
        {tipsRight.map((item, index) => {
          return (
            <div key={`tipsRight${index}`} className="tips-right">
              {item}
            </div>
          );
        })}
      </div>
    );
  }

  // 渲染示例图片 位于上传那下方 正确错误等类型
  renderImgExample() {
    const { imgExample } = this.props.dataSource;
    if (!imgExample || imgExample.length === 0) {
      return null;
    }
    return (
      <div className="example-box">
        {imgExample.map((item, index) => {
          const icon = item.status
            ? 'success okds-success-circle-fill'
            : 'error okds-fail-circle-fill';
          return (
            <div key={`example${index}`} className="example-item">
              <img className="example-img" src={item.url} alt="" />
              <div className="example-text">{item.title}</div>
              <Icon className={`state-icon ${icon}`} />
            </div>
          );
        })}
      </div>
    );
  }

  // 渲染提示
  renderTips(tips, isSpecial) {
    if (!tips || tips.length === 0) {
      return null;
    }
    return (
      <div className="tips-box">
        {tips.map((item, index) => {
          return (
            <div
              key={`tips${isSpecial ? 'Special' : ''}${index}`}
              className={`tips-item ${isSpecial ? 'especial' : ''}`}
            >
              {item}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { multiType, tips, specialTips, bottomArea } = this.props.dataSource;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={this.props.dataSource} />
        <div className="form-input-box img-input-box">
          <div className="form-upload">
            {multiType
              ? this.renderMultiTypeUpload()
              : this.renderSameTypeUpload()}
            {this.renderSampleImg()}
            {this.renderTipsRight()}
          </div>
          {bottomArea}
          <span className="form-error-tips">{errorMsg}</span>
          {this.renderImgExample()}
          {this.renderTips(tips)}
          {this.renderTips(specialTips, true)}
        </div>
      </div>
    );
  }
}
ItemUpload.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    formType: FormType.UPLOAD,
    inputAttr: {},
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
